/**
 * @author        matthew@zumper.com (Matthew Talamini)
 * @copyright     Copyright (c) 2022, Zumper
 */

import { filterActions } from '@zumper/redux-ignore'
import type { ActionTypes as DetailActionTypes } from '../../reducers/types'
import { proConDataReducer } from './reducers/index'
import { whitelist } from './reducers/whitelist'

export const prosAndCons = filterActions<
  ReturnType<typeof proConDataReducer>,
  DetailActionTypes,
  (typeof whitelist)[number]
>(proConDataReducer, whitelist)
